/* File : src/pages/GuestPages/RegistrationPage.js */
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RegistrationForm from '../../components/guest/RegistrationForm';
import { useEvent } from '../../contexts/EventContext';
import { usePayment } from '../../contexts/PaymentContext';
import { useCreator } from '../../contexts/CreatorContext';
import './GuestPages.css';

/**
 * Page d'inscription à l'événement
 * 
 * MODIFICATIONS BRIGHT NIGHT:
 * - Récupération du ticketType depuis location.state
 * - Récupération du paymentId depuis PaymentContext ou location.state
 * - Récupération du creatorCode depuis CreatorContext
 * - Ces informations sont passées au RegistrationForm
 */
const RegistrationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { eventDetails, loading, error } = useEvent();
  const { paymentData } = usePayment();
  const { creatorCode } = useCreator();
  
  // Récupérer le type de ticket et le paymentId
  const ticketType = location.state?.ticketType || 'classic';
  const paymentId = location.state?.paymentId || paymentData.paymentId || null;
  
  console.log("RegistrationPage - ticketType:", ticketType);
  console.log("RegistrationPage - paymentId:", paymentId);
  console.log("RegistrationPage - creatorCode:", creatorCode);

  // Vérifier si l'utilisateur a passé la vérification d'âge
  useEffect(() => {
    const birthYear = localStorage.getItem('birthYear');
    
    if (!birthYear) {
      navigate('/');
    }
  }, [navigate]);

  // Afficher un message de chargement pendant la récupération des détails de l'événement
  if (loading) {
    return (
      <div className="guest-page loading-page">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Chargement des informations de l'événement...</p>
        </div>
      </div>
    );
  }

  // Afficher un message d'erreur si la récupération des détails a échoué
  if (error || !eventDetails) {
    return (
      <div className="guest-page error-page">
        <div className="error-container">
          <h2>Erreur</h2>
          <p>{error || "Impossible de charger les détails de l'événement"}</p>
          <button 
            className="btn-primary" 
            onClick={() => navigate('/')}
          >
            Retour à l'accueil
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="guest-page">
      {/* Badge type de ticket */}
      {/* ✅ CORRECTION: Badge type de ticket avec nomenclature V3 */}
		<div className="ticket-type-indicator">
		  {ticketType === 'classic' && '🎁 Ticket CLASSIQUE'}
		  {ticketType === 'gold' && '🎟️ Ticket GOLD (1 500 FCFA)'}
		  {ticketType === 'vip' && '👑 Ticket VIP (50 000 FCFA)'}
		</div>
      
      {/* Formulaire d'inscription avec les props nécessaires */}
      <RegistrationForm 
        ticketType={ticketType}
        paymentId={paymentId}
        creatorCode={creatorCode}
      />
    </div>
  );
};

export default RegistrationPage;